import '@hotwired/turbo-rails';

Turbo.setProgressBarDelay(500);
